/**
 * Resolve the default notification tier for a user at a barn scope.
 * Prefers org-wide tier, then plan default ("No Notifications" or lowest sort_order).
 */
export function resolveDefaultTierId({ orgTierId, planDefaultTierId }) {
  return orgTierId || planDefaultTierId || null;
}

/**
 * Resolve the effective tier shown to the user when no explicit barn override exists.
 */
export function resolveEffectiveTierId({ explicitTierId, orgTierId, planDefaultTierId }) {
  if (explicitTierId) return explicitTierId;
  return resolveDefaultTierId({ orgTierId, planDefaultTierId });
}

/**
 * Whether a grant represents a barn tier assignment without a barn-specific access role.
 */
export function isTierOnlyGrant(grant) {
  return grant?.isTierOnly === true || (grant?.type === 'barn' && !grant?.role?.id);
}
